/**
 * Returns a list of passive endings
 *
 * @returns {string[]} Czech passive verb endings.
 */
export const endings = [
	"án",
	"ána",
	"áno",
	"áni",
	"ány",
	"ován",
	"ána",
	"áno",
	"áni",
	"ány",
	"en",
	"ena",
	"eno",
	"eni",
	"eny",
	"ěn",
	"ěna",
	"ěno",
	"ěni",
	"ěny",
	"et",
	"eta",
	"eto",
	"eti",
	"ety",
	"it",
	"ita",
	"ito",
	"iti",
	"ity",
	"at",
	"ata",
	"ato",
	"ati",
	"aty",
	"yt",
	"yta",
	"yto",
	"yti",
	"yty",
	"ut",
	"uta",
	"uto",
	"uti",
	"uty",
];

export default endings;
